import React, { Component } from "react";
import { Search, Icon } from 'semantic-ui-react'
import { invokeApig } from "../libs/awsLib";
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import config from "../config"
import { isError } from "util";
import { setTimeout } from "core-js";

// const resultRenderer = ({ id, title, image }) => <div><div className='title'>{title}</div></div>

// resultRenderer.propTypes = {
//   id: PropTypes.number,
//   title: PropTypes.string,
//   image: PropTypes.string
// }

// const categoryRenderer = ({ name }) => <div className='category'><div>{name} <Icon name='user' /></div></div>

// resultRenderer.propTypes = {
//   name: PropTypes.string
// }


export default class UserSearch extends Component {
constructor(props)
{
  super(props);
  this.state = {isLoading: false, results: [], value: '', users: []};
 
}

componentWillMount() {
    this.loadUsers()
    this.resetComponent()
  }
resetComponent = () => this.setState({ isLoading: false, results: [], value: ''})

loadUsers ()
{
  var securitygroups;
  var users;
  const promise1 = invokeApig({path: "/api/securitygroups", method: "GET",  body: null});
  const promise2 = invokeApig({path: "/api/users", method: "GET",  body: null, queryParams:['active=True']})
  
  Promise.all([promise1, promise2]).then((result)=>
  {
    securitygroups = result[0].data
    users = result[1].data

    var servesecuritygroups=[];
    for (var securitygroup in securitygroups) {
      if (1 in securitygroups[securitygroup].applications)
        servesecuritygroups.push(securitygroups[securitygroup].id)
    }

    var serveusers=[];
    for (var user of users) {
      for (var sg of servesecuritygroups) {
        if (user.securitygroups.includes(sg)){
          serveusers.push(user);
          break;
        }
      }
    }
    this.setState({users: serveusers});
  });
}


handleResultSelect = (e, { result }) => {
      this.setState({value: result.title});
      this.props.onSelect(result.id);
      }
handleSearchChange = (e, { value }) => {
  setTimeout(()=>{
  this.setState({ isLoading: true, value: value, results: [] })
  if (value)
  {
    // this.setState({ isLoading: true, value: value, results: [] })
    const searchresults=this.state.users.filter(user=>{return (user.firstname.toLowerCase()+' '+user.lastname.toLowerCase()).includes(value.toLowerCase()) }).map(user=>{
      return {id: user.id, title: user.firstname+' '+user.lastname, image: 'http://oct-user-images-' + config.stage + '.s3.eu-west-2.amazonaws.com/' + user.id+ '.png'}
    })

    this.setState({ isLoading: false, results: searchresults })
    
  }
  else
  {
    this.setState({ isLoading: false, value: '', results: [] })
  }
}, 300)
  }



  render() {

    return (


    <Search loading={this.state.isLoading}
    onResultSelect={this.handleResultSelect}
    onSearchChange={this.handleSearchChange}
    results={this.state.results}
    value={this.state.value}
  />)
  }
}